import { ElementTranstionDto, SceneTypeDto } from "@repo/api/overlays";
import ElementTimingControls from "./ElementTimingControls";
import ElementAnimationControls from "./ElementAnimationControls";
import { CompositionTimings } from "@repo/video-engine-i2v/utils/timing";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { useCallback } from "react";

type Props = {
  element: {
    externalId: string;
    enterAt: ElementTranstionDto;
    exitAt: ElementTranstionDto;
  };
  fieldName: "enterAt" | "exitAt";
  sceneType: SceneTypeDto;
  compositionTimings: CompositionTimings;
};

export default function ElementTransitionSection({
  element,
  fieldName,
  sceneType,
  compositionTimings,
}: Props) {
  const seekToElement = useEditorStore((state) => state.service.seekToElement);

  const onTimingChange = useCallback(() => {
    seekToElement(element.externalId, sceneType);
  }, [seekToElement, element.externalId, sceneType]);

  return (
    <>
      <div className="mt-8 flex gap-8 border-t border-border pt-6">
        <ElementTimingControls
          element={element}
          fieldName={fieldName}
          sceneType={sceneType}
          compositionTimings={compositionTimings}
          onTimingChange={onTimingChange}
        />
        <ElementAnimationControls
          element={element}
          fieldName={fieldName}
          sceneType={sceneType}
          compositionTimings={compositionTimings}
          onTimingChange={onTimingChange}
        />
      </div>
    </>
  );
}
